import { Container, TipsBar, Button, Video } from '@/components'
import styles from './styles.module.scss'
import thumbnailUrl from '/public/images/thumbnail-home.webp'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const HeroHome = ({
  showTipBar = true,
  heroTitle = '',
  heroSubtitle = '',
  buttonText = 'EXPERIMENTAR AGORA',
  buttonID = 'btn-section-hero',
  buttonVideoID = 'btn-play-video-hero-home',
  linkVideo = 'https://player-vz-52e90812-1b5.tv.pandavideo.com.br/embed/?v=634aeae1-763c-4a71-a720-6ddca2e14b1b',
  variant,
  customClassButton
}) => {
  const { onClickItem } = useClickWithScroll()

  return (
    <>
      {showTipBar && (
        <TipsBar text={'TREINOS AO VIVO E GRAVADOS • EXPERIMENTE POR 7 DIAS'} />
      )}
      <section className={`fgt-section ${styles.hero} ${styles[variant]}`}>
        <div className={styles.background}>
          <div className={styles.content}>
            <Container classname={styles.container}>
              <div className={styles.content}>
                <h1 className={styles.title}>
                  {heroTitle || (
                    <>
                      A <span>Maior </span>academia de aulas online ao vivo{' '}
                      <span>do mundo</span>
                    </>
                  )}
                </h1>
                <p className={styles.description}>
                  {heroSubtitle || (
                    <>
                      A Academia Foguete é uma plataforma com aulas online e ao
                      vivo para você treinar de onde e quando quiser.
                    </>
                  )}
                </p>

                <div className={styles.video}>
                  <Video
                    text={'Assista agora'}
                    url={linkVideo}
                    buttonId={buttonVideoID}
                    thumbnailUrl={thumbnailUrl}
                    videoAutoplay={true}
                  />
                </div>

                <Button
                  id={buttonID}
                  variant="primary"
                  className={`${styles.cta} ${customClassButton}`}
                  onClick={() => {
                    onClickItem('comparePlans', 0)
                  }}
                >
                  {buttonText}
                </Button>
              </div>
            </Container>
          </div>
        </div>
      </section>
    </>
  )
}

export default HeroHome
